module.exports = __webpack_public_path__ + "img/logo_底部.9a77ba5e.png";